import { render, staticRenderFns } from "./select-regist.vue?vue&type=template&id=53d6d8e4&"
import script from "./select-regist.vue?vue&type=script&lang=js&"
export * from "./select-regist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports